import { createSlice } from '@reduxjs/toolkit';

const loadBreadcrumbs = () => {
    const data = sessionStorage.getItem('breadcrumbs');
    const breadcrumbs = data ? JSON.parse(data) : [];

    if (breadcrumbs.length === 0) {
        breadcrumbs.push({
            name: 'Home',
            icon: 'Icon%20Hotel,%20Food%20&%20Beverages.svg',
            route: '/dashboard',
        });
        sessionStorage.setItem('breadcrumbs', JSON.stringify(breadcrumbs));
    }

    return breadcrumbs;
};

const breadcrumbSlice = createSlice({
    name: 'breadcrumb',
    initialState: loadBreadcrumbs(),
    reducers: {
        pushBreadcrumb: (state, action) => {
            state.push(action.payload);
            sessionStorage.setItem('breadcrumbs', JSON.stringify(state));
        },
        popBreadcrumb: (state, action) => {
            const index = action.payload; 
            const updatedState = state.slice(0, index+1); 
            sessionStorage.setItem('breadcrumbs', JSON.stringify(updatedState));
            return updatedState;
        },
        headPopBreadcrumb: (state) => {
            const updatedState = state.slice(0, -1); 
            sessionStorage.setItem('breadcrumbs', JSON.stringify(updatedState));
            return updatedState;
        },
        clearBreadcrumbs: () => {
            sessionStorage.removeItem('breadcrumbs');
            return [
                {
                    name: 'Home',
                    icon: 'Icon%20Hotel,%20Food%20&%20Beverages.svg',
                    route: '/dashboard',
                },
            ];
        },
    },
});

export const { pushBreadcrumb, popBreadcrumb, clearBreadcrumbs, headPopBreadcrumb } = breadcrumbSlice.actions;
export default breadcrumbSlice.reducer;
